<template>
  <model-form
    ref="modelForm"
    :model="pagerRequestType"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-gutter-md items-start q-mt-sm">
        <span class="text-body1 text-bold">
          General
        </span>
      </div>
      <div class="row q-gutter-md items-start">
        <span class="text-caption">
          <ul>
            <li>The internal name is used on the Point of Sale to identify the pager request type.</li>
            <li>The display name is used on the consumer website to display the pager request type.</li>
          </ul>
        </span>
      </div>
      <div class="row q-gutter-md items-start">
        <q-input
          v-model="pagerRequestType.name"
          class="col"
          label="Internal Name"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
          autofocus
        />
        <q-input
          v-model="pagerRequestType.displayName"
          class="col"
          label="Display Name"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
        />
      </div>
      <div class="row q-gutter-md items-start">
        <span class="text-body1 text-bold">
          Icon
        </span>
      </div>
      <div class="row q-gutter-md items-start">
        <span class="text-caption">
          <ul>
            <li>The icon is used on the consumer website to display the pager request type.</li>
          </ul>
        </span>
      </div>
      <div class="row q-gutter-md q-mt-sm items-start">
        <q-btn
          v-if="$_.isNil(pagerRequestType.icon)"
          label="Select Icon"
          class="col-6 q-mb-lg"
          @click="$refs.iconPickerDialog.show()"
        />
        <q-btn
          v-else
          :icon="pagerRequestType.icon"
          size="lg"
          class="col-6"
          outline
          color="primary"
          @click="$refs.iconPickerDialog.show()"
        />
      </div>
      <div class="row items-start q-mt-sm">
        <div class="row full-width">
          <span class="text-body1 text-bold">
            Availability
          </span>
        </div>
        <div class="row q-gutter-md items-start">
          <span class="text-caption">
            <ul>
              <li>The pager request type will be available at the selected delivery locations.</li>
            </ul>
          </span>
        </div>
        <div class="row full-width">
          <q-select
            v-model="pagerRequestType.deliveryLocationIds"
            class="col-12"
            label="Delivery Locations"
            multiple
            :options="deliveryLocations.data"
            option-label="name"
            option-value="id"
            emit-value
            map-options
            use-chips
          />
        </div>
        <div class="row">
          <q-btn
            :label="isAllDeliveryLocationsSelected ? 'Remove All' : 'Add All'"
            :icon="isAllDeliveryLocationsSelected ? 'remove_circle' : 'add_circle'"
            color="primary"
            class="q-mt-xs"
            rounded
            @click="toggleAllDeliveryLocations"
          />
        </div>
      </div>

      <div class="row q-gutter-md items-start q-mt-sm">
        <span class="text-body1 text-bold">
          Preview
        </span>
      </div>
      <div class="row items-start q-mt-sm">
        <q-btn
          :label="pagerRequestType.displayName"
          color="primary"
          size="lg"
          class="full-width q-mx-md q-mb-md"
          :icon="pagerRequestType.icon"
        />
      </div>
      <icon-picker-dialog
        ref="iconPickerDialog"
        :model="pagerRequestType"
        icon-property="icon"
        :allow-custom-image="false"
      />
    </div>
  </model-form>
</template>
<script>

import IconPickerDialog from 'src/modules/admin/components/IconPickerDialog'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'PagerRequestTypeForm',
  configuration: ['deliveryLocations'],
  components: {
    IconPickerDialog,
    ModelForm
  },
  models: {
    pagerRequestType: {
      editing: true,
      deliveryLocations: 'default'
    }
  },
  computed: {
    isAllDeliveryLocationsSelected () {
      return _.differenceBy(this.deliveryLocations.data, this.pagerRequestType.deliveryLocations.data, 'id').length === 0
    }
  },
  methods: {
    toggleAllDeliveryLocations () {
      if (this.isAllDeliveryLocationsSelected) {
        this.pagerRequestType.deliveryLocationIds = []
      } else {
        this.pagerRequestType.deliveryLocationIds = _.map(this.deliveryLocations.data, 'id')
      }
    }
  }
}

</script>
